import React, { useContext } from "react";
import EditModal from "../../profiles/EditModal";
import { MediaProfileContext } from "../data/media_profile_context_management";
import HeaderModalBody from "./header_modal_body";
import PublicationsModalBody from "./publications_modal_body";
import ContactModalBody from "./contact_modal_body";

// Media Profile's edit modal: consumes the shared <EditModal> shell (chrome only) and keeps the
// engine-specific section -> body mapping + title here (mirrors pr_profiles/edit/edit_modal.jsx).
// The bodies own their own <Modal.Body>/<Modal.Footer> (the shell renders children raw). Not yet
// mounted anywhere — the show-page wiring mounts it.
function MediaProfileEditModal() {
  const { mediaProfile, openEditModal, setOpenEditModal, setGeneralError } = useContext(MediaProfileContext);

  const closeModal = () => {
    setOpenEditModal(null);
    setGeneralError(null);
  };

  const sectionLabel = () => {
    switch (openEditModal) {
      case "HEADER":
        return " - Header Details";
      case "PUBLICATIONS":
        return " - Employment";
      case "CONTACT":
        return " - Contact Info";
      default:
        return null;
    }
  };

  const body = () => {
    // Both bodies read the loaded profile + their plumbing (mediaProfileId, silentReload,
    // setGeneralError, ...) from MediaProfileContext; they take only `close` as a prop.
    switch (openEditModal) {
      case "HEADER":
        return <HeaderModalBody close={closeModal} />;
      case "PUBLICATIONS":
        return <PublicationsModalBody close={closeModal} />;
      case "CONTACT":
        return <ContactModalBody close={closeModal} />;
      default:
        return null;
    }
  };

  return (
    <EditModal
      show={!!openEditModal}
      onClose={closeModal}
      fullscreen="lg-down"
      title={
        <>
          Editing {mediaProfile?.name}
          {sectionLabel()}
        </>
      }
    >
      {body()}
    </EditModal>
  );
}

export default MediaProfileEditModal;
